export const DATA_KEY = '_datamedIQ'
export const STATUS_SUCCESS = [201]
